import React, { useState } from "react";
import { useQuery } from "react-query";
import { deleteAddsOne, editAddsOne, editAddsOneGroup, getAddsOneGroup } from "../../../MyApi/addsone";
import DataTable from "../../UI/table/DataTable";
import StatusBadge from "../../UI/statusBadge";
import TableActions from "../../UI/table/TableActions";
import AddsOneEditModal from "../../stores/storesStore/addsoneEditModal";
import { formatPrice } from "../../../utils/formatPrice";
import i18next from "i18next";
import AddOnGroupModal from "../storesStore/addoneGroupModal";

const AddonsInfo = ({ store_id, currency_factor }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalMode, setModalMode] = useState("add");
  const [selectedAddonId, setSelectedAddonId] = useState(null);

  const [isGroupModalOpen, setIsGroupModalOpen] = useState(false);
const [selectedGroupId, setSelectedGroupId] = useState(null);
const [groupModalMode, setGroupModalMode] = useState("add");

  // Fetch add-on groups
  const { data, isLoading, refetch, isFetching } = useQuery(
    ["getAddsOneGroup", store_id, currentPage],
    () => getAddsOneGroup(store_id, currentPage),
    { keepPreviousData: true, staleTime: 5 * 60 * 1000 }
  );

  // Flatten add-ons for DataTable
  const addons =
    data?.data?.add_on_groups?.flatMap((group) =>
      group.add_ons.map((addon) => ({
        ...addon,
        group_id: group.id,
        group_name: group.name,
        is_active: group.is_active,
      }))
    ) || [];

  const totalItems = data?.data?.pagination?.total || 0;
  const lastPage = data?.data?.pagination?.last_page || 0;

  // Open modal for add/edit

const handleOpenGroupModal = (mode, id = null) => {
  setGroupModalMode(mode);
  setSelectedGroupId(id);
  setIsGroupModalOpen(true);
};

const closeGroupModal = () => {
  setIsGroupModalOpen(false);
  setGroupModalMode("add");
  setSelectedGroupId(null);
};
  const handleOpenModal = (mode, addonId = null) => {
    setModalMode(mode);
    setSelectedAddonId(addonId);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setModalMode("add");
    setSelectedAddonId(null);
  };

  // Table columns
  const addonGroupColumns = [ 
    { label: "معرف المجموعة", render: (row) => <span style={{ color: "green" }}>#{row.id}</span> },
    { label: "اسم المجموعة", accessor: "name" },
        { label: "الحالة", render: (row) => <StatusBadge status={row.is_active ? "active" : "inactive"} /> },

     {
      label: "الإجراءات",
      render: (row) => (
        <TableActions
          isLoading={isLoading}
          editPermission="update_addon"
          deletePermission="delete_addon"
         
          refetch={refetch}
          edit={() => handleOpenGroupModal("edit", row.id)}
       
          id={row.id}
          mutationKey="deleteAddsOne"
          togglePermission="update_addon"
          toggleMutationKey="toggle-update-addon"
          toggleFn={( id, status) =>
            editAddsOneGroup(
              { _method: "PUT", is_active: status, applicable_to: "product", lang: i18next.language ,store_id:store_id },
              row.group_id
            )
          }
          is_active={row.is_active}
        />
      ),
    },
  ]
  const addonColumns = [
    { label: "معرف الإضافة", render: (row) => <span style={{ color: "green" }}>#{row.id}</span> },
    { label: "مجموعة الإضافة", accessor: "group_name" },
    { label: "اسم الإضافة", accessor: "name" },
    {
      label: "السعر",
      render: (row) =>
        row.price ? `${formatPrice(currency_factor, row.price)} ${row.symbol_currency || ""}` : "___",
    },
    { label: "الحالة", render: (row) => <StatusBadge status={row.is_active ? "active" : "inactive"} /> },
    {
      label: "الإجراءات",
      render: (row) => (
        <TableActions
          isLoading={isLoading}
          editPermission="update_addon"
          deletePermission="delete_addon"
          show={`${process.env.PUBLIC_URL}/addon/${row.id}`}
          refetch={refetch}
          edit={() => handleOpenModal("edit", row.id)}
       
          id={row.id}
          mutationKey="deleteAddsOne"
          togglePermission="update_addon"
          toggleMutationKey="toggle-update-addon"
          toggleFn={( id, status) =>
            editAddsOneGroup(
              { _method: "PUT", is_active: status, applicable_to: "product", lang: i18next.language ,store_id:store_id },
              row.group_id
            )
          }
          is_active={row.is_active}
        />
      ),
    },
  ];

  return (
    <div>
{isGroupModalOpen && (
  <AddOnGroupModal
    isOpen={isGroupModalOpen}
    toggle={closeGroupModal}
    refetchGroups={refetch}
    store_id={store_id}
    groupId={selectedGroupId}
    mode={groupModalMode}
  />
)}
      <DataTable
        title="مجموعات الإضافات"
        isLoading={isLoading}
        data={data?.data?.add_on_groups || []}
        columns={addonGroupColumns}
        isFetching={isFetching}
        createPermission="create_addon"
        onAddClick={() => handleOpenGroupModal("add")}
        actionLabel="إضافة  مجموعة إضافات"
        totalItems={totalItems}
        currentPage={currentPage}
        itemsPerPage={lastPage}
        setCurrentPage={setCurrentPage}
      />
      <DataTable
        title="الإضافات"
        isLoading={isLoading}
        data={addons}
        columns={addonColumns}
        isFetching={isFetching}
        createPermission="create_addon"
        onAddClick={() => handleOpenModal("add")}
        actionLabel="إضافة إضافة"
        totalItems={totalItems}
        currentPage={currentPage}
        itemsPerPage={lastPage}
        setCurrentPage={setCurrentPage}
      />

      {isModalOpen && (
        <AddsOneEditModal
          isOpen={isModalOpen}
          closeModal={closeModal}
          refetch={refetch}
          store_id={store_id}
          addonId={selectedAddonId}
          modalMode={modalMode}
          currency_factor={currency_factor}
        />
      )}
    </div>
  );
};

export default AddonsInfo;